import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import { BackToTop } from "./components/back-to-top/BackToTop";
import { Routes } from "./routes";

function App() {
  const routes = React.useMemo(
    () =>
      Object.keys(Routes).map((path) => {
        const RouteComponent = Routes[path];

        return (
          <Route key={path} path={path}>
            <RouteComponent />
          </Route>
        );
      }),
    []
  );

  return (
    <div>
      <Switch>{routes}</Switch>
      <BackToTop />
    </div>
  );
}

export default App;
